import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=9571d99a&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9571d99a')) {
      api.createRecord('9571d99a', component.options)
    } else {
      api.reload('9571d99a', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=9571d99a&", function () {
      api.rerender('9571d99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ydrpk9orsoMV/JS/videoIframe.vue"
export default component.exports